export default __webpack_public_path__ + "static/media/narin.5ef51cd0.png";